import { createApi } from '@reduxjs/toolkit/query/react';

import baseQuery from 'src/utils/baseQuery';

// ----------------------------------------------------------------------

const DASHBOARD_API = {
  call: 'api/calls/dashboard',
  message: 'api/messages/dashboard',
  ticket: 'api/tickets/dashboard',
  conversation: 'api/conversations/countConversation',
  company: 'api/company/dashboard',
  contact: 'api/contacts/dashboard',
  user: 'api/users/dashboard',
  channel: 'api/channels/dashboard',
};

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery,
  endpoints: (builder) => ({
    getCallDetails: builder.mutation({
      query: (requestApi) => ({
        url: DASHBOARD_API.call,
        method: 'POST',
        body: requestApi,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    getMessageDetails: builder.mutation({
      query: (requestApi: any) => ({
        url: DASHBOARD_API.message,
        method: 'POST',
        body: requestApi,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    getTicketCount: builder.mutation({
      query: (requestApi: any) => ({
        url: DASHBOARD_API.ticket,
        method: 'POST',
        body: requestApi,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    getCallGraphDetail: builder.mutation({
      query: (requestApi: any) => ({
        url: DASHBOARD_API.call,
        method: 'POST',
        body: { ...requestApi, isGraph: true },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    getConversationDetail: builder.mutation({
      query: (requestApi: any) => ({
        url: DASHBOARD_API.conversation,
        method: 'POST',
        body: requestApi,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    getAccountCount: builder.mutation({
      query: (requestApi: any) => ({
        url: DASHBOARD_API.company,
        method: 'POST',
        body: requestApi,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    getContactCount: builder.mutation({
      query: (requestApi: any) => ({
        url: DASHBOARD_API.contact,
        method: 'POST',
        body: requestApi,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    getUserCount: builder.mutation({
      query: (requestApi: any) => ({
        url: DASHBOARD_API.user,
        method: 'POST',
        body: requestApi,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    getChannelCount: builder.mutation({
      query: (requestApi: any) => ({
        url: DASHBOARD_API.channel,
        method: 'POST',
        body: requestApi,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
  }),
});

export const {
  useGetCallDetailsMutation,
  useGetMessageDetailsMutation,
  useGetTicketCountMutation,
  useGetCallGraphDetailMutation,
  useGetConversationDetailMutation,
  useGetAccountCountMutation,
  useGetContactCountMutation,
  useGetUserCountMutation,
  useGetChannelCountMutation,
} = dashboardApi;
